<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">MAPA DE ESTABLECIMIENTOS</span>
        </div>
        <span class="custom">Mapa donde se muestra la ubicación de los establecimientos</span>
    </div>
    <div class="body">

        <div class="mapa-container">
            <div id="map" class="height"></div>
            <!--<agm-map (mapClick)="close_window()" [latitude]="lat" [longitude]="lng" [zoom]="zoom" 
            [mapTypeControl]="true" mapTypeId="hybrid">
                <agm-marker *ngFor="let establecimiento of establecimientosData" [latitude]="establecimiento.est_lat" 
                [longitude]="establecimiento.est_lng" iconUrl="assets/images/marker.png" (markerClick)=select_marker(infoWindow)>
                    <agm-info-window #infoWindow [disableAutoPan]="true">
                        <div class="window-container">
                            <div class="contenido-establecimiento1">
                                <h2 style="margin-bottom: 15px; font-size: 18px; font-weight: 500;">{{establecimiento.est_name}}</h2>
                                <img [src]="urlBase + '/uploads/imgs/' + establecimiento.est_imgs" 
                                style="height: 150px;">
                              </div>
                              <div class="contenido-establecimiento2">
                                <button mat-mini-fab matTooltip="Ver establecimiento" color="warn" aria-label="Ver establecimiento" 
                                routerLink="/establecimiento/{{establecimiento.id}}" style="box-shadow: none;">
                                  <mat-icon>remove_red_eye</mat-icon>
                                </button>
                                <button mat-mini-fab *ngIf="userData.pro_id == 4" matTooltip="Editar establecimiento" 
                                color="warn" aria-label="Editar establecimiento" routerLink="/{{establecimiento.id}}/editar/establecimiento"
                                style="box-shadow: none; margin-left: 10px;">
                                  <mat-icon>edit</mat-icon>
                                </button>
                                <a mat-mini-fab matTooltip="Ver en Google Maps" color="warn" aria-label="Ver en Google Maps" 
                                [href]="'https://www.google.com/maps/search/?api=1&query=' + establecimiento.est_lat + ',' + establecimiento.est_lng" target="_blank"
                                style="box-shadow: none; margin-left: 10px;">
                                    <mat-icon>map</mat-icon>
                                </a>
                              </div>
                        </div>
                      </agm-info-window>
                </agm-marker>
            </agm-map>-->
        </div>
    </div>
</div>
<div class="footer"></div>
